module.exports = __webpack_public_path__ + "img/more-skin.29d80d8d.png";